import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/faq/listFaqs.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getFaqs = (params) => __async(null, null, function* () {
  var _a;
  try {
    const locale = getLocaleOnly((params == null ? void 0 : params.locale) || "en");
    const search = new URLSearchParams();
    search.append("lang", locale);
    if (params == null ? void 0 : params.per_page) {
      search.append("per_page", (_a = params == null ? void 0 : params.per_page) == null ? void 0 : _a.toString());
    }
    const data = yield fetchClient({
      url: `/faqs?${search.toString()}`
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getFaqsException"
    });
  }
});
var getFaqsByGroup = (params) => __async(null, null, function* () {
  var _a, _b;
  try {
    const search = new URLSearchParams();
    search.append("lang", getLocaleOnly((params == null ? void 0 : params.locale) || "en"));
    search.append("faq_group", params.faq_group);
    if (params == null ? void 0 : params.organization_slug) {
      search.append("organization_slug", params.organization_slug);
    }
    if (params == null ? void 0 : params.page) {
      search.append("page", (_a = params == null ? void 0 : params.page) == null ? void 0 : _a.toString());
    }
    if (params == null ? void 0 : params.per_page) {
      search.append("per_page", (_b = params == null ? void 0 : params.per_page) == null ? void 0 : _b.toString());
    }
    const data = yield fetchClient({
      url: `/faqs?${search.toString()}`
    });
    return data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getFaqsByGroupException"
    });
  }
});

export {
  getFaqs,
  getFaqsByGroup
};
//# sourceMappingURL=chunk-23V3YWBC.mjs.map